import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import marketService from "../../Api/marketService";
import walletService from "../../Api/walletService";

const initialState = {
  marketSummary: [],
  cryptoPriceList: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
};

export const getMarketSummary = createAsyncThunk(
  "get/market-summary",
  async (thunkAPI) => {
    try {
      return await marketService.getMarketSummary();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const GetCryptoPrice = createAsyncThunk(
  "get/crypto_price",
  async (_, thunkAPI) => {
    try {
      return await walletService.GetCryptoPrice();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const marketSlice = createSlice({
  name: "market",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMarketSummary.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(getMarketSummary.fulfilled, (state, action) => {
        state.marketSummary = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(getMarketSummary.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      })
      .addCase(GetCryptoPrice.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(GetCryptoPrice.fulfilled, (state, action) => {
        state.cryptoPriceList = action?.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(GetCryptoPrice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.error =
          action?.payload?.code === "ERR_NETWORK"
            ? action?.payload?.message
            : action?.payload?.response?.data?.message;
      });
  },
});

export default marketSlice.reducer;
